// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2osGw","large":"styles_large__1J6ay"};